import { SvgIcon } from "@mui/material";
import { FC } from "react";

const HomeIcon: FC = (props) => (
  <SvgIcon {...props} viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.285 7.66473C15.6993 7.66473 16.035 8.00052 16.035 8.41473V12.4422C16.035 13.1752 15.7439 13.8782 15.2256 14.3965C14.7073 14.9148 14.0043 15.206 13.2713 15.206H5.14281C4.40981 15.206 3.70684 14.9148 3.18854 14.3965C2.67025 13.8782 2.37904 13.1752 2.37904 12.4422V10.5222C2.37904 10.108 2.71483 9.77223 3.12904 9.77223C3.54326 9.77223 3.87904 10.108 3.87904 10.5222V12.4422C3.87904 12.7774 4.01219 13.0988 4.2492 13.3358C4.48621 13.5728 4.80766 13.706 5.14281 13.706H13.2713C13.6065 13.706 13.9279 13.5728 14.1649 13.3358C14.4019 13.0988 14.535 12.7774 14.535 12.4422V8.41473C14.535 8.00052 14.8708 7.66473 15.285 7.66473Z"
      fill="#036BAE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.79159 0.626093C9.04361 0.457969 9.37202 0.457969 9.62403 0.626093L17.3318 5.76808C17.6764 5.99796 17.7694 6.46364 17.5395 6.80821C17.3096 7.15279 16.8439 7.24577 16.4994 7.0159L9.20781 2.15158L3.97574 5.64199H11.0453C11.4595 5.64199 11.7953 5.97778 11.7953 6.39199C11.7953 6.8062 11.4595 7.14199 11.0453 7.14199H1.50006C1.1696 7.14199 0.878084 6.9257 0.782273 6.60944C0.686463 6.29318 0.808938 5.95147 1.08384 5.76808L8.79159 0.626093Z"
      fill="#036BAE"
    />
  </SvgIcon>
);

export default HomeIcon;
